import type { LatLngLiteral } from '@shared/core/google-maps/types';
import { distanceInMiles, getWalkingAndDrivingDistance } from '@shared/utils/distanceInMiles';
import type { AccommodationListingDTO } from '@shared/types/Accommodations.types';
import { WALKING_TIME_THRESHOLD_MINUTES } from '../constants';

/**
 * True when the listing is less than `WALKING_TIME_THRESHOLD_MINUTES` of walking from the event venue,
 * the rule that decides whether a card shows a walk time instead of a drive time.
 *
 * A listing with no usable location is not within a walk.
 */
export const isListingWithinWalkOfVenue = (listing: Pick<AccommodationListingDTO, 'location'>, venueLocation: LatLngLiteral): boolean => {
  const miles = distanceInMiles(venueLocation, listing.location);
  if (miles === null) {
    return false;
  }
  return getWalkingAndDrivingDistance(miles).walking < WALKING_TIME_THRESHOLD_MINUTES;
};
